/*
  SR-CUSTOM: regional free-shipping messaging.
  - Converts [data-sr-fs-amount] (A$ cents) in the announcement bar into the
    visitor's currency, rounded UP to the nearest 10 so the figure shown always qualifies.
  - Patches the cart's <shipping-notification> so international carts show the
    remaining amount in the visitor's currency (the stock theme showed it in A$).
  Thresholds themselves live in Shopify shipping zones and in
  snippets/cart-shipping-notification.liquid; keep them in sync.
*/
(function () {
  function rate() {
    return (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  }
  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
  }
  function format(cents, wholeOnly) {
    try {
      return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currency(),
        minimumFractionDigits: wholeOnly ? 0 : 2,
        maximumFractionDigits: wholeOnly ? 0 : 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(wholeOnly ? 0 : 2);
    }
  }
  // Shop-currency cents -> local cents, rounded up to a whole 10 units.
  function localThreshold(shopCents) {
    return Math.ceil((shopCents * rate()) / 1000) * 1000;
  }

  function updateAnnouncements() {
    document.querySelectorAll('[data-sr-fs-amount]').forEach(function (el) {
      var shopCents = parseInt(el.getAttribute('data-sr-fs-amount'), 10);
      if (shopCents > 0) el.textContent = format(localThreshold(shopCents), true);
    });
  }

  function patchedUpdate() {
    if (!this.elementMessageParagraph) return;
    var threshold = localThreshold(this.freeShippingThreshold);
    var total = this.cartTotal; // already in local currency cents
    if (total >= threshold) {
      this.classList.add('threshold-reached');
      this.elementMessageParagraph.innerHTML = window.cartStrings.shipping_free;
      if (this.elementLevelBarFill) this.elementLevelBarFill.style.setProperty('--fill-width', '100%');
    } else {
      var missing = threshold - total;
      this.classList.remove('threshold-reached');
      if (this.elementLevelBarFill) this.elementLevelBarFill.style.setProperty('--fill-width', (total / threshold) * 100 + '%');
      this.elementMessageParagraph.innerHTML = window.cartStrings.shipping_not_free.replace('[amount]', format(missing, false));
    }
  }

  function patchCartBar() {
    if (!window.customElements) return;
    customElements.whenDefined('shipping-notification').then(function () {
      var C = customElements.get('shipping-notification');
      if (!C || C.prototype.__srPatched) return;
      C.prototype.updateShippingNotification = patchedUpdate;
      C.prototype.__srPatched = true;
      document.querySelectorAll('shipping-notification[data-calc-in-js]').forEach(function (el) {
        if (!el.elementMessageParagraph) {
          el.elementMessageParagraph = el.querySelector('.free-shipping-message');
          el.elementLevelBarFill = el.querySelector('.level-bar-fill');
        }
        el.updateShippingNotification();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAnnouncements);
  } else {
    updateAnnouncements();
  }
  patchCartBar();
})();
